import { lowerCase, startCase } from 'lodash'
import { formatToBR } from '../../../utils/date'

// eslint-disable-next-line import/prefer-default-export
export const serializerExtract = (data, walletCode) => ({
  store: {
    cnpj: data.store?.cnpj,
    nameFantasy: startCase(lowerCase(data.store?.nameFantasy)),
    tabNumber: data.store?.tabNumber,
    walletCode,
    subsidiary: data.store?.subsidiary,
    website: data.store?.website,
    email: data.store?.email,
    addressStreet: data.store?.addressStreet,
    addressNumber: data.store?.addressNumber,
    addressComplement: data.store?.addressComplement,
    addressNeighborhood: data.store?.addressNeighborhood,
    addressCity: data.store?.addressCity,
    addressUf: data.store?.addressUf,
    addressPostalCode: data.store?.addressPostalCode,
    hasManyFlags: data.store?.hasManyFlags,
    flag: data.store?.flag,
    hasShopping: data.store?.hasShopping,
    shoppingCnpj: data.store?.shoppingCnpj,
    shoppingWebsite: data.store?.shoppingWebsite,
    phoneNumberDdd: data.store?.phoneNumberDdd,
    phoneNumber: data.store?.phoneNumber,
    phoneNumberSalesmanDdd: data.store?.phoneNumberSalesmanDdd,
    phoneNumberSalesman: data.store?.phoneNumberSalesman,
    nameOwner: data.store?.nameOwner,
    nameFinancialDirector: data.store?.nameFinancialDirector,
    nameCommercialDirector: data.store?.nameCommercialDirector,
    nameSalesman: data.store?.nameSalesman,
    nameFactory: data.store?.nameFactory,
    agentCertifiedName: data.store?.agentCertifiedName,
    agentCertifiedExpiredAt:
      data.store?.agentCertifiedExpiredAt &&
      formatToBR(data.store?.agentCertifiedExpiredAt),
    norkonExpiredAt:
      data.store?.norkonExpiredAt && formatToBR(data.store?.norkonExpiredAt),
    hasGroup: data.store?.hasGroup,
    groupCnpjMatriz: data.store?.groupCnpjMatriz,
    groupCode: data.store?.groupCnpjMatriz,
    groupName: data.store?.groupName,
    logoImageUrl: data.store?.logoImageUrl
  },
  indicators: {
    classifications: data.indicators?.classifications.map((classification) => ({
      identifier: classification?.identifier,
      name: classification?.name,
      value: classification?.value,
      valueMinimum: classification?.valueMinimum,
      valuePenult: classification?.valuePenult,
      description: classification?.description,
      referenceAt: classification?.referenceAt,
      codeColor: classification?.codeColor,
      formatId: classification?.formatId,
      periodicityName: classification?.periodicityName,
      categoryId: classification?.categoryId,
      categoryName: classification?.categoryName,
      order: classification?.order,
      hasDetails: classification?.hasDetails
    })),
    priorities: data.indicators?.priorities.map((prioritie) => ({
      identifier: prioritie?.identifier,
      name: prioritie?.name,
      value: prioritie?.value,
      valueMinimum: prioritie?.valueMinimum,
      valuePenult: prioritie?.valuePenult,
      description: prioritie?.description,
      referenceAt: prioritie?.referenceAt,
      codeColor: prioritie?.codeColor,
      formatId: prioritie?.formatId,
      periodicityName: prioritie?.periodicityName,
      categoryId: prioritie?.categoryId,
      categoryName: prioritie?.categoryName,
      order: prioritie?.order,
      hasDetails: prioritie?.hasDetails
    })),
    profiles: data.indicators?.profiles.map((profile) => ({
      identifier: profile?.identifier,
      name: profile?.name,
      value: profile?.value,
      valueMinimum: profile?.valueMinimum,
      valuePenult: profile?.valuePenult,
      description: profile?.description,
      referenceAt: profile?.referenceAt,
      codeColor: profile?.codeColor,
      formatId: profile?.formatId,
      periodicityName: profile?.periodicityName,
      categoryId: profile?.categoryId,
      categoryName: profile?.categoryName,
      order: profile?.order,
      hasDetails: profile?.hasDetails
    })),
    managements: data.indicators?.managements.map((management) => ({
      ...management,
      identifier: management?.identifier,
      title: management?.name,
      subtitle: management?.categoryName,
      description: management?.description,
      updatedAt: management?.referenceAt,
      page: `/extrato/${walletCode}/detalhe/gerencial/${management?.identifier}`,
      periods: [
        {
          id: 1,
          type: 0,
          value: management?.valueMinimum,
          decrease: true
        },
        {
          id: 2,
          type: 1,
          value: management?.valuePenult,
          decrease: false
        },
        {
          id: 3,
          type: 2,
          value: management?.value,
          decrease: false
        }
      ],
      periodicityName: management?.periodicityName,
      hasDetails: management?.hasDetails
    }))
  },
  products: data.products,
  yearMonth: data.yearMonth,
  currentYear: `${data.yearMonth}`.substr(0, 4),
  currentMonth: `${data.yearMonth}`.substr(4)
})

export const serializerExtractLevelTwo = (data) =>
  data.map((item) => ({
    identifier: item?.identifier,
    name: item?.name,
    value: item?.value,
    valueMinimum: item?.valueMinimum,
    valuePenult: item?.valuePenult,
    description: item?.description,
    referenceAt: item?.referenceAt,
    codeColor: item?.codeColor,
    formatId: item?.formatId,
    periodicityName: item?.periodicityName,
    categoryId: item?.categoryId,
    categoryName: item?.categoryName || 'Category Name',
    order: item?.order,
    hasDetails: item?.hasDetails
  }))

export const serializerExtractLevelThree = (data) =>
  serializerExtractLevelTwo(data)
